import moment from "moment";
import React, { Component } from "react";
import FlexView from "react-flexview";
import { connect } from "react-redux";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { setError } from "../../../../../Redux/ErrorRedux";
import Api from "../../../../../Services/Api";
import { fetchDataAsync } from "../../../../../Services/Utils";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import Container from "../../../../../modules/commons/Container";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import { mapToObjectDDL } from "../../../../common/mapper";
import { monthOptions, yearOptions } from "../../config";
import { HttpStatus } from "../../../../common/Constants";
import SimpleMultiHeaderTable from "../../../../../modules/SimpleMultiHeaderTable";
import { generatePayloadPrint, groupHeaders, tableConfig } from "./config";
import { saveAs } from "file-saver";
class DashboardMonitoringKPBKabengKacab extends Component {
  constructor(props) {
    super(props);
    this.currentMonth = Number(moment().format("MM"));
    this.currentYear = Number(moment().format("YYYY"));

    this.state = {
      cabangOptions: [],
      kodeCabang: null,
      search: {},
      month: monthOptions.find((item) => item.value === this.currentMonth),
      year: yearOptions.find((item) => item.value === this.currentYear),
      loading: false,
      doSearch: false,
    };
  }

  componentDidMount() {
    this.fetchDataCabang();
  }

  fetchDataCabang = async () => {
    this.handleTriggerLoading();
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
      setError: this.props.setError,
      menuName: "Dashboard CRM Kabeng Kacab - Monitoring KPB",
    });
    this.handleTriggerLoading();
    if (res.ok) {
      let filteredData = res.data.data.filter((item) =>
        this.props.menuAccess
          .map((data) => data.idRefObj)
          .includes(item.kodeCabang),
      );

      if (filteredData.length !== 0) {
        this.setState(
          (prev) => ({
            ...prev,
            cabangOptions: filteredData.map((item) =>
              mapToObjectDDL(item.namaDealer, item.kodeCabang),
            ),
            kodeCabang: mapToObjectDDL(
              filteredData[0].namaDealer,
              filteredData[0].kodeCabang,
            ),
          }),
          () => this.handleSearch(),
        );
      }
    }
  };

  handleChangeValue = (name, value) => {
    this.setState((prevValue) => ({ ...prevValue, [name]: value }));
  };

  handleTriggerLoading = () => {
    this.setState((prev) => ({ ...prev, loading: !prev.loading }));
  };

  capitalizeWords = (str = "") =>
    str.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());

  fetchData = async () => {
    const { setError } = this.props;
    const { kodeCabang, month, year } = this.state;
    this.handleTriggerLoading();

    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanStatistikKPB,
      setError: setError,
      menuName: "Dashboard CRM Kabeng Kacab - Monitoring KPB",
      args: {
        kodeCabang: kodeCabang?.value,
        month: month?.value,
        year: year?.value,
      },
    });

    this.handleTriggerLoading();

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState({
        dataTable: res.data.data.map((item) => ({
          name: this.capitalizeWords(item.type || ""),
          totalEngineNumber: item.totalEngineNumber,

          kpb1NotUsed: item.kpb1?.notUsed || 0,
          kpb1NotUsedPercentage: item.kpb1?.notUsedPercentage || 0,
          kpb1Used: item.kpb1?.used || 0,
          kpb1UsedPercentage: item.kpb1?.usedPercentage || 0,
          kpb1Expired: item.kpb1?.expired || 0,
          kpb1ExpiredPercentage: item.kpb1?.expiredPercentage || 0,

          kpb2NotUsed: item.kpb2?.notUsed || 0,
          kpb2NotUsedPercentage: item.kpb2?.notUsedPercentage || 0,
          kpb2Used: item.kpb2?.used || 0,
          kpb2UsedPercentage: item.kpb2?.usedPercentage || 0,
          kpb2Expired: item.kpb2?.expired || 0,
          kpb2ExpiredPercentage: item.kpb2?.expiredPercentage || 0,

          kpb3NotUsed: item.kpb3?.notUsed || 0,
          kpb3NotUsedPercentage: item.kpb3?.notUsedPercentage || 0,
          kpb3Used: item.kpb3?.used || 0,
          kpb3UsedPercentage: item.kpb3?.usedPercentage || 0,
          kpb3Expired: item.kpb3?.expired || 0,
          kpb3ExpiredPercentage: item.kpb3?.expiredPercentage || 0,

          kpb4NotUsed: item.kpb4?.notUsed || 0,
          kpb4NotUsedPercentage: item.kpb4?.notUsedPercentage || 0,
          kpb4Used: item.kpb4?.used || 0,
          kpb4UsedPercentage: item.kpb4?.usedPercentage || 0,
          kpb4Expired: item.kpb4?.expired || 0,
          kpb4ExpiredPercentage: item.kpb4?.expiredPercentage || 0,
        })),
      });
    }
  };

  handleSearch = () => {
    this.fetchData();
  };

  handlePrint = async () => {
    const { setError } = this.props;
    const { dataTable } = this.state;
    this.handleTriggerLoading();
    const title = "Laporan Monitoring KPB CRM Kabeng Kacab";
    const fileName = title.split(" ").join("_");

    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_REPORT").generateAdvancedExcelFromPayload,
      setError: setError,
      menuName: "Dashboard CRM Kabeng Kacab - Laporan Monitoring KPB",
      args: generatePayloadPrint(dataTable),
    });
    this.handleTriggerLoading();
    if (res.ok) {
      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, fileName + ".xlsx");
    }
  };

  render() {
    const { cabangOptions, kodeCabang, month, year, loading, dataTable } =
      this.state;
    return (
      <React.Fragment>
        <Container>
          <FlexView
            style={{ gap: "20px", alignItems: "center" }}
            className="margin-top-15px"
          >
            <h1 className="txt-site txt-11 txt-main txt-bold margin-bottom-20px">
              Cabang
            </h1>
            <SimpleDDL
              box="search"
              id="select_options_kode_cabang"
              name="kodeCabang"
              containerclassname="width width-500px"
              placeholder="Nama Cabang"
              options={cabangOptions}
              value={kodeCabang}
              onChange={(value, { name }) =>
                this.handleChangeValue(name, value)
              }
            />
          </FlexView>
          <FlexView className="margin-top-15px" style={{ gap: "20px" }}>
            <SimpleDDL
              id="select_options_bulan"
              box="search"
              name="month"
              containerclassname="width width-150px"
              placeholder="Bulan"
              options={monthOptions}
              value={month}
              onChange={(value, { name }) =>
                this.handleChangeValue(name, value)
              }
            />
            <SimpleDDL
              id="select_options_tahun"
              box="search"
              name="year"
              containerclassname="width width-150px"
              placeholder="Tahun"
              options={yearOptions}
              value={year}
              onChange={(value, { name }) =>
                this.handleChangeValue(name, value)
              }
            />
            <SimpleButton
              id="btn_search"
              text="Cari"
              className="margin margin-top-5px"
              onClick={() => this.handleSearch()}
            />
          </FlexView>
          <Tabs>
            <TabList>
              <Tab>Laporan Statistik KPB</Tab>
            </TabList>
            <TabPanel key="kpb">
              <SimpleMultiHeaderTable
                data={dataTable}
                columns={tableConfig}
                groupHeaders={groupHeaders}
              />
              <FlexView hAlignContent="right" className="margin-top-20px">
                <SimpleButton
                  id="btn_print"
                  text="Cetak"
                  onClick={() => this.handlePrint()}
                />
              </FlexView>
            </TabPanel>
          </Tabs>
        </Container>
        {loading && <SimpleLoadingOverlay active={loading} />}
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  setError: (payload) => dispatch(setError(payload)),
});

const mapStateToProps = (state) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DashboardMonitoringKPBKabengKacab);
